module.exports = __webpack_public_path__ + "img/2026-06_research-and-innovation.663d62e2.webp";